// Google Ads (compte Novasoft Tech 131-741-2317) — intégration à consentement strict.
//
// RÈGLES (directive client, oct. 2026) :
//  - La balise gtag.js n'est chargée QUE si le consentement cookies du site vaut
//    "accepted" (bannière existante réutilisée — pas de catégories distinctes,
//    l'acceptation vaut consentement marketing). Refus, « plus tard » ou absence
//    de choix (ou valeur sentinelle "snapshot" du prerender) → AUCUN script,
//    window.dataLayer/gtag restent indéfinis, aucun cookie publicitaire.
//  - Prerender : la valeur "snapshot" posée par scripts/prerender_snapshots.py
//    n'est jamais "accepted" → la balise n'est jamais figée dans le HTML statique.
//  - Pas d'enhanced conversions (désactivé côté compte — aucune donnée personnelle
//    transmise dans les événements).
//  - L'idempotence des conversions est garantie côté appelant (ref par soumission).

export const GADS_ID = "AW-18342279927";
export const GADS_CONV_ACCOMPAGNEMENT = "AW-18342279927/2QNqCOjt_JAdEPf1o6pE";

const CONSENT_KEY = "novaimmo-cookie-consent";
let loaded = false;

const hasMarketingConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
};

const loadAdsTag = () => {
  if (loaded || !hasMarketingConsent()) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GADS_ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`;
  document.head.appendChild(s);
};

// À appeler une fois au montage de l'app : charge la balise si le consentement
// est déjà donné, et réagit au choix fait dans la bannière (événement émis par
// CookieBanner) — un refus ne charge rien.
export const initAds = () => {
  loadAdsTag();
  window.addEventListener("novaimmo:cookie-consent", loadAdsTag);
};

// Émet une conversion Google Ads. Silencieux et sans effet si le consentement
// n'a pas été donné (gtag jamais chargé). Aucune donnée personnelle.
export const trackConversion = (sendTo) => {
  if (!hasMarketingConsent() || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo });
};
